




















import { Component, Vue, Prop } from 'vue-property-decorator';
import http from '../tools/http-client';
import { ValidationError } from '../errors';

@Component
export default class TweetForm extends Vue {

  private static TWEET_MAX_LENGTH = 272;

  private tweet: string = '';
  private posting: boolean = false;
  private tweetMmaxLength = TweetForm.TWEET_MAX_LENGTH;

  @Prop({required: true, default: null})
  private eventPathPhrase!: string | null;

  private get tweetMaxLength(): number {
    return TweetForm.TWEET_MAX_LENGTH;
  }

  private postTweet(): void {

    this.posting = true;

    const url = `${process.env.VUE_APP_API_URL_BASE}tweets?epp=${this.eventPathPhrase}`;
    http.post(url, {contents: this.tweet}).then(() => {
      this.tweet = '';
      alert('つぶやき完了！');
    }).catch((error) => {
      if (!(error instanceof ValidationError)) throw error;
      alert('入力チェックエラーです。 ');
    }).then(() => {
      this.posting = false;
    });

  }

}
